import api from './api';

// Jobs
export const createJob = (jobData) =>
  api.post('/api/job/createjob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Create job error:', error);
      throw error;
    });

export const retrieveJob = (jobData) =>
  api.post('/api/job/retrievejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve job error:', error);
      throw error;
    });

export const getJob = (jobId) =>
  api.post('/api/job/getjob', { jobId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get job error:', error);
      throw error;
    });

export const getJobs = (params) =>
  api.post('/api/job/getjobs', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get jobs error:', error);
      throw error;
    });

export const updateJob = (jobData) =>
  api.post('/api/job/updatejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update job error:', error);
      throw error;
    });

export const cancelJob = (jobData) =>
  api.post('/api/job/canceljob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Cancel job error:', error);
      throw error;
    });

export const deleteJob = (jobData) =>
  api.post('/api/job/deletejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Delete job error:', error);
      throw error;
    });

export const archiveJob = (jobData) =>
  api.post('/api/job/archivejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Archive job error:', error);
      throw error;
    });

export const unArchiveJob = (jobData) =>
  api.post('/api/job/unarchivejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Unarchive job error:', error);
      throw error;
    });

export const archiveMavJob = (jobData) =>
  api.post('/api/job/archivemavjob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Archive mav job error:', error);
      throw error;
    });

export const unArchiveMavJob = (jobData) =>
  api.post('/api/job/unarchivemavjob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Unarchive mav job error:', error);
      throw error;
    });

export const completeJob = (jobData) =>
  api.post('/api/job/completejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Complete job error:', error);
      throw error;
    });

export const getretrieveJobs = (queryParams) => {
  const { filter, search, page = 1, limit = 10, sort } = queryParams;
  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
  });
  return api.get(`/api/admin/v2/jobs?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve jobs error:', error);
      throw error;
    });
};

export const getJobsRecordsCount = () =>
  api.get('/api/admin/jobRecordsCount')
    .then(r => r.data)
    .catch(error => {
      console.error('Get jobs records count error:', error);
      throw error;
    });

export const findJobs = (userData) =>
  api.post('/api/job/findjobs', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Find jobs error:', error);
      throw error;
    });

export const rateJob = (jobData) =>
  api.post('/api/job/ratejob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Rate job error:', error);
      throw error;
    });

export const cancelJobs = (queryParams) =>
  api.post('/api/job/canceljobs', queryParams)
    .then(r => r.data)
    .catch(error => {
      console.error('Cancel jobs error:', error);
      throw error;
    });

// Quotes
export const createQuote = (quoteData) =>
  api.post('/api/job/createquote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Create quote error:', error);
      throw error;
    });

export const retrieveQuote = (quoteData) =>
  api.post('/api/job/retrievequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve quote error:', error);
      throw error;
    });

export const getQuote = (quoteId) =>
  api.post('/api/job/getquote', { quoteId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get quote error:', error);
      throw error;
    });

export const getQuotes = (params) =>
  api.post('/api/job/getquotes', params)
    .then(r => r.data)
    .catch(error => {
      console.error('Get quotes error:', error);
      throw error;
    });

export const updateQuote = (quoteData) =>
  api.post('/api/job/updatequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Update quote error:', error);
      throw error;
    });

export const cancelQuote = (quoteData) =>
  api.post('/api/job/cancelquote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Cancel quote error:', error);
      throw error;
    });

export const deleteQuote = (quoteData) =>
  api.post('/api/job/deletequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Delete quote error:', error);
      throw error;
    });

export const archiveQuote = (quoteData) =>
  api.post('/api/job/archivequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Archive quote error:', error);
      throw error;
    });

export const unArchiveQuote = (quoteData) =>
  api.post('/api/job/unarchivequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Unarchive quote error:', error);
      throw error;
    });

export const retrieveJobQuotes = (jobData) =>
  api.post('/api/job/retrievejobquotes', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve job quotes error:', error);
      throw error;
    });

export const acceptQuote = (quoteData) =>
  api.post('/api/job/acceptquote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Accept quote error:', error);
      throw error;
    });

export const declineQuote = (quoteData) =>
  api.post('/api/job/declinequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Decline quote error:', error);
      throw error;
    });

export const getretrieveQuotes = (queryParams) => {
  const { filter, search, page = 1, limit = 10, sort } = queryParams;
  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
  });
  return api.get(`/api/admin/v2/quotes?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Retrieve quotes error:', error);
      throw error;
    });
};

export const getQuotesRecordsCount = () =>
  api.get('/api/admin/quoteRecordsCount')
    .then(r => r.data)
    .catch(error => {
      console.error('Get quotes records count error:', error);
      throw error;
    });

export const completeQuote = (jobData) =>
  api.post('/api/job/completequote', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Complete quote error:', error);
      throw error;
    });

export const rateQuote = (quoteData) =>
  api.post('/api/job/ratequote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Rate quote error:', error);
      throw error;
    });

export const setQuote = (quoteData) =>
  api.post('/api/job/setquote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Set quote error:', error);
      throw error;
    });

export const forcePaymentCompleted = (quoteId) =>
  api.post('/api/job/forcepaymentcompleted', { quoteId })
    .then(r => r.data)
    .catch(error => {
      console.error('Force payment completed error:', error);
      throw error;
    });
